import React from 'react';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

export const ToasterErrorIcon = () => <ErrorOutlineOutlinedIcon color="error" sx={{ fontSize: 'inherit' }} />;
